import React, { useState } from 'react'
import {  
  styled, 
  useTheme,
  Drawer,
  Divider,
  List,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material'
// rotas
import { Link } from 'react-router-dom';
// icons
import EmailIcon from '@mui/icons-material/Email';
import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArticleIcon from '@mui/icons-material/Article';
// traducciones
import { useTranslation } from 'react-i18next';

const drawerWidth = 240;

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 5),
  ...theme.mixins.toolbar,
  justifyContent: 'flex-start',
}));

const DrawerItem = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  //rotas
  const itemList = [
    {
      text: t("nav.home"),
      icon: <HomeIcon />,
      to: "/"
    },
    /* {
      text: t("nav.about"),
      icon: <InfoIcon />,
      to: "/about"
    }, */
    {
      text: t("nav.blog"),
      icon: <ArticleIcon />,
      to: "/blog"
    },
    {
      text: t("nav.contact"),
      icon: <EmailIcon />,
      to: "/contact"
    }
  ];
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton
      aria-label="open drawer"
      edge="end"
      onClick={handleDrawerOpen}
      sx={{ 
        color: 'black',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.04)',
        }
      }}
      >
        <MenuIcon />
      </IconButton>

      <Drawer
      sx={{
          '& .MuiDrawer-paper': {
          width: drawerWidth,
          },
      }}
      variant="temporary"
      anchor="right"
      open={open}
      onClose={handleDrawerClose}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'rtl' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          {itemList.map( ( item ) => {
            const { text } = item;
            return(
              <ListItem 
              key={text} 
              component={Link} 
              to={item.to}
              onClick={handleDrawerClose}
              sx={{
                color: '#414141',
                "&:hover": {
                  backgroundColor: '#e9e5e5',
                  color: '#1c2859',
                }
              }}
              >
                <ListItemIcon
                sx={{
                  "&:hover":{
                    backgroundColor: 'transparent',
                    color: '#1c2859',
                  }
                }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText primary={text} />
              </ListItem>
            )
          })}
        </List>
      </Drawer>
    </>
  )
}

export default DrawerItem;